<div id="mobileMessage" class="form-warning">❌ Metoda aceasta de calcul nu este optimizata pentru telefon, te rog să intri de pe ceva cu
  ecran mai mare
</div>
<div id="shape-editor" [ngClass]="isFullscreen ? 'shape-editor-fullscreen' : ''">
  <div id="shapeList" [style.width.px]="canvasWidth">
    <div class="control-group">
      <button mat-raised-button *ngFor="let shape of shapes; let i = index" (click)="loadShape(i)"
        [color]="currentShapeIndex === i ? 'primary' : undefined">
        {{shape.name}}
      </button>
      <button mat-raised-button (click)="newShape()">
        Formă nouă
      </button>
    </div>
    <div class="control-group">
      <button mat-raised-button id="fullScreenButton" (click)="toggleFullScreen()">
        <mat-icon>{{isFullscreen ? 'fullscreen_exit' : 'fullscreen'}}</mat-icon>
        {{isFullscreen ? 'Ieși din fullscreen' : 'Fullscreen'}}
      </button>
    </div>
  </div>
  <div id="svgControls" [style.width.px]="canvasWidth">
    <div class="control-group">
      <button mat-raised-button [disabled]="zoomLevel > 5" (click)="zoomEvent.emit({zoomValue: 1})" class="icon-button">
        <mat-icon>zoom_in</mat-icon>
      </button>
      <button [disabled]="zoomLevel <= -9" mat-raised-button (click)="zoomEvent.emit({zoomValue: -1})" class="icon-button">
        <mat-icon>zoom_out</mat-icon>
      </button>
      <div id="zoom-level">
        Zoom: {{zoomLevel}}
      </div>
    </div>
    <div class="control-group">
      <button mat-raised-button (click)="calculateTiles()" [disabled]="this.addShapeMode">
        <mat-icon>calculate</mat-icon>
        {{tiles.length > 0 ? 'Recalculează' : 'Calculează tabla'}}
      </button>
      <button *ngIf="tiles.length > 0" mat-raised-button (click)="clearTilesButtonClick()">
        <mat-icon>clear</mat-icon>
        Șterge tabla
      </button>
    </div>
    <div class="control-group">
      <button mat-raised-button (click)="clearShapeButtonClick()" class="icon-button">
        <mat-icon>clear</mat-icon>
      </button>
      <button mat-raised-button (click)="saveShapeButtonClick()" class="icon-button">
        <mat-icon>save</mat-icon>
      </button>
    </div>
  </div>
  <div id="svgSection">
    <div>
      <svg #drawSvg id="drawSvg" (mousemove)="onMouseMove($event)" (mousedown)="onMouseDown($event)"
        style="border: 1px solid black;" xmlns="<http://www.w3.org/2000/svg>"
        [style.width.px]="canvasWidth" [style.height.px]="canvasHeight" (contextmenu)="$event.preventDefault();">
        <polygon points="" fill="lightgrey" stroke="black" stroke-width="0.2"></polygon>
      </svg>
    </div>
    <div id="pointsList">
      <button color="primary" mat-raised-button (click)="openAddPointDialog()" class="add-point-button">
        <mat-icon matPrefix>add</mat-icon>
        Adaugă punct
      </button>

      <div *ngFor="let point of points; let i = index;">
        <button mat-raised-button class="modify-btn" [color]="editPoint === i ? 'primary' : undefined"
          (click)="pointAdjustClickEvent($event, i)">
          {{drawShapeService.getPointName(i)}}
          ({{formatPoint(getFullSize(point[0]) / 100)}}, {{formatPoint(getFullSize(svgHeight - point[1]) / 100)}})
        </button>
        <button mat-raised-button class="delete-point-btn" (click)="deletePoint(i)">
          <span class="material-icons">clear</span>
        </button>
      </div>
    </div>
  </div>
  <div id="bottomList" *ngIf="points.length > 2" [style.width.px]="canvasWidth">
    <span *ngFor="let point of points; let i = index;">
      <button mat-raised-button [color]="this.sideAccessories.get(currentShapeIndex)?.get(i) ? 'primary' : undefined"
        class="modify-btn" (click)="addAccessoryDialog(i)">
        {{getLineText(drawShapeService.getNamedPoints(points), i)}}
      </button>
    </span>
  </div>
  <!-- an hidden div is created to set the position of appearance of the menu-->
  <div style="visibility: hidden; position: fixed;" [style.left.px]="menuTopLeftPosition.x"
    [style.top.px]="menuTopLeftPosition.y" [matMenuTriggerFor]="rightMenu"></div>

  <mat-menu #rightMenu="matMenu" [hasBackdrop]="false">
    <ng-template matMenuContent let-items="items">
      <button mat-menu-item (click)="modifyTilesPreset(items, 0.35, 'up')">
        <span class="material-icons">arrow_upward</span> +35 cm
      </button>
      <button mat-menu-item (click)="modifyTilesPreset(items, -0.35, 'up')">
        <span class="material-icons">arrow_upward</span> -35 cm
      </button>
      <button mat-menu-item (click)="modifyTilesPreset(items, -0.35, 'down')">
        <span class="material-icons">arrow_downward</span> +35 cm
      </button>
      <button mat-menu-item (click)="modifyTilesPreset(items, 0.35, 'down')">
        <span class="material-icons">arrow_downward</span> -35 cm
      </button>
      <button mat-menu-item (click)="splitTiles(items)">
        <span class="material-icons">splitscreen</span>
        Împarte în 2 bucăți
      </button>
      <button mat-menu-item (click)="modifyTiles(items)">
        <span class="material-icons">settings</span>
        Modifică lungimea
      </button>
      <button mat-menu-item (click)="deleteTile(items)">
        <span class="material-icons">delete</span>
        Șterge
      </button>
    </ng-template>
  </mat-menu>
</div>
